import { Link } from 'react-router-dom';
import { NavMenuListProps } from './navMenuList.interface';
import { NavMenuListWrapper } from './navMenuList.styles';
import { signInSelector } from 'src/store/User/user.slice';
import { useSelector } from 'react-redux';

export default function NavMenuList({ showMenuList, callback }: NavMenuListProps) {
  const isSignedIn = useSelector(signInSelector);

  return (
    <NavMenuListWrapper
      className={`${showMenuList ? 'is-active' : ''}`}
      onClick={callback}
      callback={callback}
      showMenuList={showMenuList}
    >
      <ul>
        {!isSignedIn ? (
          <>
            <li>
              <Link to="/inversionista/registrate">Inverte | Impacta</Link>
            </li>
            <li>
              <Link to="/solicitante/registrate">Solicita crédito</Link>
            </li>
          </>
        ) : null}

        <li>
          <Link to="/quienes-somos">¿Quiénes somos?</Link>
        </li>
        <li>
          <Link to="/contratos-y-legal">Contratos e Información legal</Link>
        </li>
        <li>
          <Link to="/relacion-con-accionistas-comunidad">Relación con Accionistas</Link>
        </li>
        {/* <li>
          <Link to="/eventos-webinars">Webinar Inversiones Sustentables</Link>
        </li> */}
        <li>
          <Link to="/media">Presencia en Medios</Link>
        </li>
        {/* <li>
          <Link to="/biblioteca">Biblioteca</Link>
        </li> */}
      </ul>
    </NavMenuListWrapper>
  );
}
